<template>
  <div class="AdvertisementsAmount">
    <BarChartDisplay
      :title="$t('advertisements.quantity-sector')"
      :options="sectorsData"
      :series="series"
    />
  </div>
</template>

<script>
import { BarChartDisplay } from '@/components';
import { getAmountAdvertisements } from '@/api';

export default {
  name: 'AdvertisementsAmount',
  data() {
    return {
      sectorsData: {
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            endingShape: 'flat',
            columnWidth: '100%',
            barHeight: '70%',
            distributed: true,
          },
        },
      },
      series: [],
    };
  },
  components: {
    BarChartDisplay,
  },
  created() {
    getAmountAdvertisements().then(
      data => {
        this.series = data;
      },
      err => {
        console.log('Fetch Error: ', err);
      }
    );
  },
};
</script>

<style lang="scss">
.AdvertisementsAmount {
  width: 35%;
  margin-right: rem(10);
}
</style>
